import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";

export const teacherApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTeachers: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: { url: buildPaginationQueryString(data, `/api/user/teacher`) },
      }),
      providesTags: ["Paginated-Teachers"],
    }),
  }),
});

export const { useGetTeachersQuery } = teacherApi;
